exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.loader[data-v-b9c9bd6e] {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background: rgb(255, 255, 255);\n  text-align: center;\n  z-index: 100;\n}\n.looping-rhombuses-spinner[data-v-b9c9bd6e] {\n  display: inline-block;\n}\n.success_icon[data-v-b9c9bd6e] {\n  width: 30px;\n  height: 30px;\n  display: block;\n}\n.success_msg[data-v-b9c9bd6e] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  margin-bottom: 20px;\n}\n.success_msg>*[data-v-b9c9bd6e] {\n  margin: unset;\n}\n.none[data-v-b9c9bd6e] {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b9c9bd6e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/notifications.vue
// module id = 643
// module chunks = 0